import { styled, useTheme } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { useContext, createElement, Fragment } from 'react';
import '../../utilities/get-styleprop.js';
import '../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import Accordion from '../../Accordion/Accordion.js';
import '../../Accordion/AccordionSection.js';
import '../../H5/H5.js';
import '../../Svg-0180d7b5.js';
import Icon from '../../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../../Icon/icons.js';
import '../../Icon/helper.js';
import '../../Accordion/utils/focus.js';
import '@vebox/etui-colors';
import 'react-spring/renderprops.cjs';
import '../../Badge/Badge.js';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import '../../Button/Button.js';
import Chip from '../../Chip/Chip.js';
import 'lodash.isnil';
import '../utils.js';
import '../state/constants.js';
import { clearAll } from '../state/actions.js';
import FilterPanelContext from '../FilterPanelContext.js';
import '../Group/GroupTitle.js';
import Group from '../Group/Group.js';
import './SummarySectionChip.js';
import FilterChips from './FilterChips.js';

const FilterChipsWrapper = styled(Div)`
  display: flex;
  flex-wrap: wrap;
  max-height: 150px;
  overflow-y: auto;
`;

const SummarySection = ({
  filters,
  noFiltersSummaryLabel,
  clearAllLabel = 'Clear all',
  title = 'Filters summary ',
  fieldsMetadata
}) => {
  const theme = useTheme();
  const {
    dispatch
  } = useContext(FilterPanelContext);
  return /*#__PURE__*/createElement(Accordion, null, /*#__PURE__*/createElement(Group, {
    name: title,
    isSummary: true,
    defaultOpen: true
  }, Object.keys(filters).length ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(FilterChipsWrapper, null, /*#__PURE__*/createElement(FilterChips, {
    filters: filters,
    fieldsMetadata: fieldsMetadata
  })), /*#__PURE__*/createElement(Div, {
    mt: `${theme.spacing.xs}px`
  }, /*#__PURE__*/createElement(Chip, {
    styles: {
      wrapper: {
        bg: theme.palette.black[40]
      }
    },
    label: clearAllLabel,
    onRemove: () => dispatch(clearAll())
  }))) : /*#__PURE__*/createElement(Div, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/createElement(Icon, {
    glyph: icons.INFO_CIRCLE,
    size: 24,
    styles: {
      root: {
        mr: `${theme.spacing.xxs}px`
      }
    }
  }), noFiltersSummaryLabel)));
};

export default SummarySection;
